// extracted by mini-css-extract-plugin
export default {"container":"style_container__AyH0s","headerWrapper":"style_headerWrapper__B0PTk","contentWrapper":"style_contentWrapper__l3g2U","loadingWrapper":"style_loadingWrapper__X75Sq"};